import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import './i18n';
import i18next from 'i18next';
import { I18nextProvider } from 'react-i18next';
import { App } from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	<I18nextProvider i18n={i18next}>
		<BrowserRouter>
			<App />
		</BrowserRouter>
	</I18nextProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
